import { ComponentPropsWithoutRef } from 'react';
import { ReactNode } from 'react';

import { Root } from '@radix-ui/react-visually-hidden';

type VisuallyHiddenProps = ComponentPropsWithoutRef<typeof Root> & {
	children: ReactNode;
};

export const VisuallyHidden = ({ children, ...props }: VisuallyHiddenProps) => <Root {...props}>{children}</Root>;
